import { connect, ConnectedProps } from 'react-redux';
import { createSelector } from 'reselect';
import { StateType } from '../../state/state.types';
import { Folder } from '../folders.types';

const decisionFoldersSelector = (state: StateType, docId: string) =>
  state.decisions[docId] || [];

const foldersSelector = (state: StateType) => state.folders.folders;

const decisionFolders = createSelector(
  decisionFoldersSelector,
  foldersSelector,
  (decFolders, folders) =>
    decFolders
      .map((folderId: string) => folders[folderId])
      .sort((a: Folder, b: Folder) => a.title.localeCompare(b.title)),
);

const mapState = (state: StateType, { docId }: { docId: string }) => ({
  folders: decisionFolders(state, docId),
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
